import { Typography } from "@packages/ds";
import styled from "styled-components";

import { Link } from "ds/Button";

export const Description = styled(Typography.BodyText)`
  margin-bottom: 14px;
`;
export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  justify-content: flex-end;
  gap: 8px;

  .info-button {
    > button {
      justify-content: center;
      border-radius: var(
        --trigger-button-border-radius,
        var(--button-2px-border-radius, var(--2px))
      );
    }
  }

  @media (min-width: 768px) {
    margin-right: 0;
  }
`;

export const Layout = styled.div`
  padding-bottom: ${props => (props.noPadding ? 0 : "16px")};
  .tooltip > section {
    padding: 16px;
  }

  > section {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    box-sizing: border-box;

    @media (min-width: 960px) {
      flex-direction: row;
      > div {
        max-width: 50%;
      }
    }
  }
  #environment-urls {
    section {
      padding: 0;
      a:hover,
      a:focus {
        text-decoration: underline;
      }
    }
  }
  .rcs-custom-scroll {
    .rcs-inner-container {
      padding: 16px;
      box-sizing: border-box;
    }
    .rcs-inner-handle {
      background-color: var(
        --section-dark-tint-background-color,
        var(--dark-tint)
      );
      width: 4px;
      border-radius: 4px;
      opacity: 1;
    }
  }
  .no-scroll {
    padding: 16px;
  }
  .environment-ssh {
    max-height: 600px;
    overflow: scroll;
  }
  .tooltip-content-wrapper {
    overflow: scroll;
    width: 600px;
  }
  .info-button hr {
    margin-bottom: 0px;
  }
`;

export const LinkSSH = styled(Link)`
  font-weight: 600;
  margin-bottom: 10px;
`;
export const LinkDoc = styled(LinkSSH)`
  margin-left: 16px;
`;

export const ContentWrapper = styled.div`
  width: 568px;
  max-height: 500px;
  overflow-y: auto;
  overflow-x: auto;
`;
